export default {
    'alert.title': '提示',
};
